import { html, View } from 'rune-ts';
import klass from './ProductCardListEmptyScreen.module.scss';
import { ButtonAction } from '../../../../shared/components/atoms/ButtonAction/ButtonAction';
import { font } from '@services/MarppleShop/shared/typography';
import { IMAGE_ASSETS } from '@services/MarppleShop/shared/util/image-asset.ts';

interface EmptyScreenProps {
  klass?: string;
  image_src?: string;
  title?: string;
  body?: string;
}

interface PlusShopEmptyScreenProps extends EmptyScreenProps {
  plus_name: string;
}

/**
 * 상품목록 기본 empty screen
 *
 * @remarks 컴포넌트 쪼개지 말고 props만 넘겨서 처리할 수 있도록 변경하면 좋을 듯
 */
export class DefaultProductListEmptyScreen extends View<Required<EmptyScreenProps>> {
  constructor(props?: EmptyScreenProps) {
    const data: Required<EmptyScreenProps> = {
      klass: props?.klass ?? '',
      image_src: props?.image_src ?? IMAGE_ASSETS.DEFAULT_PRODUCT_EMPTY_SCREEN,
      title: props?.title ?? ET('mps2::product::empty::shop_title'),
      body: props?.body ?? ET('mps2::product::empty::shop_body'),
    };

    super(data);
  }

  override template() {
    return html`<div class="${klass.shop_empty} ${this.data.klass}">
      <img class=${klass.image} src="${this.data.image_src}" alt="" />
      <span class="${klass.title} ${font('20_bold', '16_bold')}">${this.data.title}</span>
      <span class="${klass.body} ${font('16_medium', '14_medium')}">${this.data.body}</span>
    </div>`;
  }
}

/**
 * 크리에이터샵의 상품 목록에서 사용하는 empty screen
 */
export class CreatorShopProductListEmptyScreen extends View<
  Required<EmptyScreenProps> & { hide_footer?: boolean }
> {
  constructor(props?: EmptyScreenProps & { hide_footer?: boolean }) {
    const data: Required<EmptyScreenProps> & { hide_footer?: boolean } = {
      klass: props?.klass ?? '',
      image_src: props?.image_src ?? IMAGE_ASSETS.CREATOR_PRODUCT_EMPTY_SCREEN,
      title: props?.title ?? ET('mps2::product::empty::creator_title'),
      body: props?.body ?? ET('mps2::product::empty::creator_body'),
      hide_footer: props?.hide_footer ?? false,
    };

    super(data);
  }

  override template() {
    return html`<div class="${klass.creator_shop_empty} ${this.data.klass}">
      <img class=${klass.image} src="${this.data.image_src}" alt="" />
      <span class="${klass.title} ${font('20_bold', '16_bold')}">${this.data.title}</span>
      <span class="${klass.body} ${font('16_medium', '14_medium')}"
        >${html.preventEscape(this.data.body)}</span
      >
      ${this.data.hide_footer
        ? null
        : html`<a href="/${ET.lang}" class="${klass.footer}">
            ${new ButtonAction({
              label: ET('mps2::product::empty::creator_footer'),
              type: 'blue',
              size: 'large',
            })}
          </a>`}
    </div>`;
  }
}

/**
 * 플러스샵의 상품 목록에서 사용하는 empty screen
 */
export class PlusShopProductListEmptyScreen extends View<Required<PlusShopEmptyScreenProps>> {
  constructor(props: PlusShopEmptyScreenProps) {
    const data: Required<PlusShopEmptyScreenProps> = {
      klass: props.klass ?? '',
      image_src: props.image_src ?? IMAGE_ASSETS.CREATOR_PRODUCT_EMPTY_SCREEN,
      title: props.title ?? ET('mps2::product::empty::creator_title'),
      body: props.body ?? ET('mps2::product::empty::plus_shop_body', { name: props?.plus_name }),
      plus_name: props.plus_name,
    };

    super(data);
  }

  override template() {
    return html`<div class="${klass.plus_shop_empty} ${this.data.klass}">
      <img class=${klass.image} src="${this.data.image_src}" alt="" />
      <span class="${klass.title} ${font('20_bold', '16_bold')}">${this.data.title}</span>
      <span class="${klass.body} ${font('16_medium', '14_medium')}">
        ${html.preventEscape(this.data.body)}
      </span>
    </div>`;
  }
}
